import { createUseStyles } from 'react-jss';

const styles = {
  comparisonHeader: {
    margin: { top: '5.6rem', bottom: '5.2rem', left: 'auto', right: 'auto' },
    maxWidth: '109.6rem',
    '& p': {
      maxWidth: '50rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
